// this was autogenerated by gulpTimezonePlugin from the timezone source in node_modules
(window.__PRELOADED_TIMEZONE_DATA__ || (window.__PRELOADED_TIMEZONE_DATA__ = {}))['ms_MY']  = {
  "name": "ms_MY",
  "day": {
    "abbrev": [
      "Ahd",
      "Isn",
      "Sel",
      "Rab",
      "Kha",
      "Jum",
      "Sab"
    ],
    "full": [
      "Ahad",
      "Isnin",
      "Selasa",
      "Rabu",
      "Khamis",
      "Jumaat",
      "Sabtu"
    ]
  },
  "month": {
    "abbrev": [
      "Jan",
      "Feb",
      "Mac",
      "Apr",
      "Mei",
      "Jun",
      "Jul",
      "Ogos",
      "Sep",
      "Okt",
      "Nov",
      "Dis"
    ],
    "full": [
      "Januari",
      "Februari",
      "Mac",
      "April",
      "Mei",
      "Jun",
      "Julai",
      "Ogos",
      "September",
      "Oktober",
      "November",
      "Disember"
    ]
  },
  "meridiem": [
    "",
    ""
  ],
  "date": "%A %d %b %Y",
  "time24": "%I:%M:%S  %Z",
  "dateTime": "%A %d %b %Y %I:%M:%S %p %Z",
  "time12": "%I:%M:%S %p %Z"
}

